module.exports = __webpack_public_path__ + "media/images/map/call-5edc3460505cb094d13deb8d0fb56d39.svg";